import StartInvestCompanyRequirements from "../components/forms/start-invest-requirements/StartInvestCompanyRequirements";

function CompanyFormRequirements() {
  return <StartInvestCompanyRequirements />;
}

export default CompanyFormRequirements;
